<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed h-screen w-full top-0 mdMax:max-w-screen-sm mx-auto lg:flex lg:justify-center lg:items-center lg:w-full lg:h-full lg:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    *ngIf="isDesktop$ | async"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="bg-white mdMax:h-full w-full lg:max-w-screen-sm md:h-5/6 lg:max-h-85-screen lg:rounded-lg overflow-y-auto"
    [style.z-index]="(index$ | async) + 50"
  >
    <div class="h-64 relative">
      <img
        *ngIf="shopImageCover"
        class="absolute object-cover h-64 w-full"
        src="{{ shopImageCover }}"
        alt=""
      />
      <div
        class="absolute right right-5 lg:right-8 top-5"
        [class.top-8]="isNotched"
      >
        <app-rounded-icon-button
          [size]="'sm'"
          [color]="'primary'"
          [type]="'normal'"
          icon="icon-cross"
          (onClick)="close()"
        ></app-rounded-icon-button>
      </div>
    </div>
    <div class="m-5 lg:mx-8 pb-5 border-b border-neutral-300">
      <app-shop-description-atom
        [name]="shop[shopKeys.Name]"
        [description]="shop[shopKeys.Description]"
        [shortDescription]="shop[shopKeys.ShortDescription]"
        [category]="shop[shopKeys.Type]?.name"
      ></app-shop-description-atom>
    </div>
    <div>
      <app-shop-address-atom
        [address]="shop[shopKeys.Venue]?.address.street_line1"
        [postcode]="shop[shopKeys.Venue]?.address.postal_code"
        [city]="shop[shopKeys.Venue]?.address?.city"
        [localization]="true"
        (getLocalization)="locateShop(shop)"
      ></app-shop-address-atom>
    </div>
    <div class="mx-5 lg:mx-8 lg: border-b border-neutral-300"></div>
    <div
      *ngIf="shop[shopKeys.Schedules]"
      class="mx-5 lg:mx-8 py-5 border-b border-neutral-300 cursor-pointer"
    >
      <app-shop-schedules-atom
        [schedules]="shop[shopKeys.Schedules]"
        [isShopMoveable]="shop[shopKeys.Moveable]"
      ></app-shop-schedules-atom>
    </div>
    <div
      *ngIf="!shop[shopKeys.Schedules]"
      class="mx-5 lg:mx-8 py-5 border-b border-neutral-300 cursor-pointer"
    >
      <p class="font-accent font-bold text-xl">
        {{ 'shop-informations.actually-closed' | translate }}
      </p>
    </div>
    <div
      *ngIf="shop[shopKeys.ContactEmail] || shop[shopKeys.Phone]"
      class="pt-3 px-5 lg:px-8 pb-5 mb-1 font-base font-normal text-neutral-600"
    >
      <div class="font-accent text-md lg:text-2xl font-bold leading-6 text-black">
        {{ 'shop-informations.contact' | translate }}
      </div>
      <div class="text-base lg:text-md">
        <p
          class="py-2"
          *ngIf="shop[shopKeys.ContactEmail]"
        >
          {{ 'shop-informations.email' | translate }} :
          <a [href]="'mailto:' + shop[shopKeys.ContactEmail]">{{ shop[shopKeys.ContactEmail] }}</a>
        </p>
        <p *ngIf="shop[shopKeys.Phone]">
          {{ 'shop-informations.phone' | translate }} :
          <a [href]="'tel:' + shop[shopKeys.Phone]">{{ shop[shopKeys.Phone] }}</a>
        </p>
      </div>
    </div>
  </div>
</div>
